<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Limites</label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn color="info" @click="novo()" class="ma-2 white--text">
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="limites.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row> </v-container
    ><v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="limites"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.valorLimite="{ item }">
          {{ formatCurrency(item.valorLimite) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span> </v-tooltip
          ><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                class="mr-2"
                @click="excluir(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="750px"
      ><v-card>
        <v-card-title>
          <span class="headline">{{ this.labelModal }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="validFrm2" lazy-validation>
              <v-row align="center">
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="usuarioSelected"
                    :items="criar == true ? filteredUsuarios : usuarios"
                    label="Usuário *"
                    item-text="nome"
                    item-value="id"
                    persistent-hint
                    return-object
                    :readonly="!criar"
                    :rules="[(v) => !!v || 'O Usuário é obrigatório']"
                    required
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <vuetify-money
                    v-model="valorLimite"
                    label="Valor do Limite *"
                    v-bind:options="options"
                    :rules="[(v) => !!v || 'O Valor Limite é obrigatório']"
                    required
                  />
                </v-col>
              </v-row>
            </v-form>
            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn @click="close" color="error" class="mr-4">
                  Cancelar
                </v-btn>
                <v-btn @click="enviar" color="success" class="mr-4">
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  downloadLista,
  enviarLimiteAsync,
  editarLimiteAsync,
  excluirLimiteAsync,
} from "../../../services/limiteService";
import { VMoney } from "v-money";

export default {
  name: "listalimites",
  data() {
    return {
      loading: false,
      showModal: false,
      search: "",
      valorLimite: null,
      idLimite: null,
      perfilSelected: null,
      usuarioSelected: null,
      labelModal: "",
      criar: false,
      label: "Valor do Limite",
      options: {
        locale: "pt-BR",
        prefix: "R$",
        precision: 2,
      },
      headers: [
        { text: "Perfil", value: "perfil" },
        { text: "Usuário", value: "usuario" },
        { text: "Valor do limite", value: "valorLimite" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  directives: { money: VMoney },
  computed: {
    ...mapState("limite", ["limites"]),
    ...mapState("usuario", ["usuarios"]),
    ...mapState("perfil", ["perfis"]),

    filteredPerfis() {
      return this.perfis.filter((p) => {
        return p.ativo === true;
      });
    },
    filteredUsuarios() {
      return this.usuarios.filter((u) => {
        if (!u.ativo) {
          return false;
        }
        const usuarioTemLimite = this.limites.some((limite) => {
          return limite.idUsuario === u.id;
        });
        return !usuarioTemLimite;
      });
    },
  },
  methods: {
    ...mapActions("limite", ["atualizarLimites", "atualizarLimite"]),
    ...mapActions("usuario", ["atualizarUsuarios"]),
    ...mapActions("perfil", ["atualizarPerfis"]),

    async enviar() {
      if (this.$refs.form.validate()) {
        if (this.criar) {
          const resposta = await enviarLimiteAsync(
            this.usuarioSelected.id,
            this.valorLimite
          );
          if (resposta) {
            this.$alert(
              resposta.message,
              "Descupe, falha na operação!",
              "error"
            );
          } else {
            this.$store.dispatch("ui/showSnackbar", {
              text: "Salvo com sucesso!",
              color: "success",
              timeout: 3000,
            });
            this.atualizarLimites();
          }
        } else {
          const resposta = await editarLimiteAsync(
            this.idLimite,
            this.usuarioSelected.id,
            this.valorLimite
          );
          if (resposta) {
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.$store.dispatch("ui/showSnackbar", {
              text: "Atualizado com sucesso!",
              color: "success",
              timeout: 3000,
            });
            this.atualizarLimites();
          }
        }
        this.close();
      }
    },
    editar(limite) {
      this.showModal = true;
      this.labelModal = "Editar Limite";
      this.criar = false;
      this.valorLimite = limite.valorLimite;
      this.idLimite = limite.id;
      this.usuarioSelected = this.findUsuario(limite.idUsuario);
    },
    async excluir(item) {
      try {
        await this.$confirm(
          "Tem certeza que deseja excluir este limite? Esta ação não poderá ser desfeita.",
          "Confirmação",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Não",
            type: "warning",
          }
        );
        const resposta = await excluirLimiteAsync(
          item.id,
          item.idUsuario,
          item.valorLimite
        );
        if (resposta == null) {
          this.$alert(
            resposta.message,
            "Desculpe, falha na operação!",
            "error"
          );
        } else {
          this.$store.dispatch("ui/showSnackbar", {
            text: "Limite excluído!",
            color: "success",
            timeout: 3000,
          });
          this.atualizarLimites();
        }
      } catch (e) {
        console.log("Cancelado pelo usuário");
      }
    },
    novo() {
      this.showModal = true;
      this.labelModal = "Criar Limite";
      this.criar = true;
    },
    close() {
      this.showModal = false;
      this.labelModal = "";
      this.criar = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    baixarlista() {
      downloadLista();
    },
    findPerfil(perfilId) {
      return this.perfis.find((pf) => pf.id === perfilId && pf.ativo == true);
    },
    findUsuario(usuarioId) {
      return this.usuarios.find((u) => u.id === usuarioId);
    },
    formatCurrency(valorLimite) {
      var value = parseFloat(valorLimite);
      return "R$" + value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    doAjax() {
      this.atualizarLimites();
      /*setTimeout(() => {
        this.isLoading = false;
      }, 5000);*/
      if (!this.usuarios || this.usuarios.length == 0) {
        this.atualizarUsuarios();
      }
      if (!this.perfis || this.perfis.length == 0) {
        this.atualizarPerfis();
      }
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarLimites();
      this.loading = false;
    },
  },
  created: function () {
    this.doAjax();
    this.obterLista();
  },
};
</script>
